<template>
    <table class="table phaseTable table-bordered table-hover">
        <thead>
            <tr>
                <th scope="col"> </th>
                <th scope="col" v-for="label in dataChart.labels" :key="label.id"> {{ label }} </th>
            </tr>
        </thead>
        <tbody>
            <!-- <tr v-for="phaseScores in dataChart.datasets" :key="phaseScores.id">
                <th scope="row"> {{ phaseScores.label }}</th>
                <td v-for="score in phaseScores.data" :key="score.id">{{ score }} </td>
            </tr> -->
            <tr>
                <th scope="row"> {{ dataChart.datasets[0].label }}</th>
                <td v-for="score in dataChart.datasets[0].data" :key="score.id" >{{ score }}  </td>
            </tr>
            <tr>
                <th scope="row"> {{ dataChart.datasets[1].label }}</th>
                <td v-for="score in dataChart.datasets[1].data" :key="score.id" >{{ score }} </td>
            </tr>
            <tr>
                <th scope="row"> Differenz {{ dataChart.datasets[0].label }} und {{ dataChart.datasets[1].label }}</th>
                <td v-for="index in dataChart.datasets[0].data.length" :key="index.id" :class="[(getDiffScore(index-1, 0, 1) < 0)?'red':'green']">{{ getDiffScore(index-1, 0, 1)}} </td>
            </tr>
            <tr>
                <th scope="row"> {{ dataChart.datasets[2].label }}</th>
                <td v-for="score in dataChart.datasets[2].data" :key="score.id">{{ score }}  </td>
            </tr>
           <tr>
                <th scope="row"> Differenz {{ dataChart.datasets[0].label }} und {{ dataChart.datasets[2].label }}</th>
                <td v-for="index in dataChart.datasets[0].data.length" :key="index.id" :class="[(getDiffScore(index-1, 0, 1) < 0)?'red':'green']">{{ getDiffScore(index-1, 0, 2)}} </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "PhaseTable",
    props: ["dataChart"],
    data: function() {
        return {
            // tableData: null
        }  
    },
    created() {
        // this.addDifference();
    },
    methods: {
        // addDifference(){
        //     for(let i = 0; i < this.dataChart.datasets.length; i++){
        //         this.tableData.push(this.dataChart.datasets.at(i)) ;
        //         if(i == 1 ){
        //             for(let n = 0; n < this.dataChart.datasets.at(i).length; n++){
        //                 let difArr = this.dataChart.datasets[1].map((x, j) => (x - this.dataChart.datasets[1][j]));
        //                 let difLabel = "Differenz " + this.dataChart.datasets[1].label + " und "+ this.dataChart.datasets.at(i).label;
        //                 this.tableData.push({label: difLabel, data: difArr });
        //                 console.log("Added difference " + difLabel + " with values " + difArr);
        //             }
        //         }
        //     }
        // },
        getDiffScore(index, pos1, pos2){  
            if(this.dataChart.datasets[pos1].data[index] !== 'kA' && this.dataChart.datasets[pos2].data[index] !== 'kA'){
                            let diff = this.dataChart.datasets[pos1].data[index] - this.dataChart.datasets[pos2].data[index];
            return Math.round(diff * 100) / 100;
            }
            else return 'kA';

        }
        
    }
};
</script>
<style scoped>
    .red{
        color: #b62424;
    }

    .green{
        color: #179C7D;
    }
</style>
